/**
 * @module explore/components/explore_cta
 */
import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Attribute from 'marketing/common/attribute';
import partial from 'lodash/partial';
import { trackClickWithMixpanel } from 'common/tracking';

/**
 * Component rendering additional data for users viewing the explore
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */

const CREATIVE_CTA = {
  title: 'Find a designer or namer',
  content: 'Crowdspring has one of the largest communities of designers and namers in the world. Find an experienced designer or namer to help with your unique creative needs.',
  buttonText: 'Work 1-to-1',
  buttonURL: '/start-a-project/start-1-1/',
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_explore_tea-squares_gernet-2x.png',
  imageContainerClass: 'artwork-container creative',
  attributeTo: 'Gernet',
  attributeText: 'awarded entry by',
}

const PROJECT_CTA = {
  title: 'Start your project now',
  content: 'Thousands of people like you have used crowdspring for their business needs. Answer a few questions, receive dozens of submissions and select the one you like best.',
  buttonText: 'Get Started',
  buttonURL: '/start-a-project/',
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_explore_idea-bank_ckone-2x.jpg',
  imageContainerClass: 'artwork-container projects',
  attributeTo: 'ckone',
  attributeText: 'awarded entry by',
}

const ExploreCTA = ({ anonymous, getStartedEventTracking, howItWorksEventTracking }) => {

  const Content = anonymous ? CREATIVE_CTA : PROJECT_CTA;

  return (
    <section className="explore-cta">
      <div className="row">
        <div className="small-16 medium-10 large-8 columns">
          <div className="explore-cta-content">
            { anonymous? <h1>{ Content.title }</h1> : <h2>{ Content.title }</h2> }
            <div className="explore-cta-text">
              { Content.content }
            </div>
          </div>
          <div className="cta-buttons">
            <Link className="btn btn-primary btn-lg" to={Content.buttonURL}>
              <span onClick={getStartedEventTracking ? partial(trackClickWithMixpanel, getStartedEventTracking.eventName, getStartedEventTracking.eventData) : () => {} }>
                      {Content.buttonText}
              </span>
            </Link>
            <Link className="btn btn-text" to="/how-it-works/">
              <span onClick={howItWorksEventTracking ? partial(trackClickWithMixpanel, howItWorksEventTracking.eventName, howItWorksEventTracking.eventData) : () => {} }>
                How it Works <i className="fa fa-long-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
        <div className="medium-6 large-8 columns">
          <div className={Content.imageContainerClass}>
            <img src={Content.image} alt="" className="artwork"/>
            <Attribute to={Content.attributeTo} text={Content.attributeText}/>
          </div>
        </div>
      </div>
    </section>
  );
};

ExploreCTA.propTypes = {
  anonymous: PropTypes.bool,
};

export default ExploreCTA;



// WEBPACK FOOTER //
// ./explore/components/explore_cta.jsx